import { render, staticRenderFns } from "./BizSplit.vue?vue&type=template&id=1fe6403c&"
import script from "./BizSplit.vue?vue&type=script&lang=js&"
export * from "./BizSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports